document.addEventListener("DOMContentLoaded", function () {
  // Sticky Header
  const header = document.querySelector('.site-header');
  const scrollThreshold = 1;

  function updateHeaderClass() {
    if (!header) return; // Guard clause for page editor
    
    if (window.scrollY > scrollThreshold) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  // Check on page load
  updateHeaderClass();

  // Check on scroll
  document.addEventListener("scroll", updateHeaderClass);

  // Mobile Navigation - Offcanvas
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const body = document.body;

  if (mobileMenuToggle && mobileMenu) {
    // Create overlay element
    const overlay = document.createElement('div');
    overlay.classList.add('mobile-menu-overlay');
    body.appendChild(overlay);

    // Open mobile menu
    function openMobileMenu() {
      mobileMenuToggle.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      overlay.classList.add('active');
      body.style.overflow = 'hidden';

      const firstMenuItem = mobileMenu.querySelector('a');
      if (firstMenuItem) {
        firstMenuItem.focus();
      }
    }

    // Close mobile menu
    function closeMobileMenu() {
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('active');
      body.style.overflow = '';
      mobileMenuToggle.focus();
    }

    // Toggle mobile menu
    mobileMenuToggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      isExpanded ? closeMobileMenu() : openMobileMenu();
    });

    // Close on overlay click
    overlay.addEventListener('click', closeMobileMenu);

    // Close with Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
        closeMobileMenu();
      }
    });

    // Close on menu link click
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMobileMenu);
    });

    // Handle window resize
    window.addEventListener('resize', function() {
      if (window.innerWidth > 890) {
        closeMobileMenu();
      }
    });
  }
});

